// import externalRoutes from "../../routes/externalRoutes";
import routes, { dashboardRoute } from "../../routes/routes";

const notificationURLs = {
  invitation_expired: routes.Reseller.clients,
  SEPA_verification_failed: "external",
  loan_refused: routes.Financing.loans,
  loan_accepted: routes.Financing.loans,
  loan_updated: routes.Financing.loans,
  loan_expired: routes.Financing.loans,
  creditLine_created: dashboardRoute,
  creditLine_updated: dashboardRoute,
  new_admin: routes.Settings.users,
};

export default notificationURLs;
